var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 col-7 py-2"},[(_vm.isResidential)?_c('ResidentialMenu'):_vm._e(),(_vm.isEnterpriseAdmin || _vm.isEnterpriseUser)?_c('EnterpriseMenu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }